import { type ForwardedRef, forwardRef } from 'react';
import { type HtmlPropsWithoutClassNameAndStyle } from './types';
import styles from './Typography.module.css';

export type Props = HtmlPropsWithoutClassNameAndStyle<'hgroup', object>;

/**
 * A `Heading` and the `Paragraph` under it, with the gap between them taken from the title's size
 * (design/10-foundations.md, "A title and its supporting line"): `xl` under a 24px or 32px title, `lg`
 * under 20px, `md` under 16px and 14px. Inside a `Modal` a 20px title takes `xl`, which the modal sets
 * through `--ds-heading-group-gap-xl`.
 *
 * The gap is the component's job because the type primitives trim their text box to cap height and
 * baseline: two of them stacked with no gap touch, and the small gaps that look right with untrimmed
 * text look cramped here. It sets only that gap. The space from the group to the content below it is
 * the parent's `gap`, and the title and subtitle still take their size, leading and colour from the
 * table.
 */
export const HeadingGroup = forwardRef(function _HeadingGroup(
  { children, ...rest }: Props,
  ref: ForwardedRef<HTMLElement>,
) {
  return (
    <hgroup {...rest} ref={ref} className={styles.headingGroup}>
      {children}
    </hgroup>
  );
});
